import { IMultiLanguageValue } from '../../../common/interfaces/MultiLanguageValue.interface';
import { BroadcastType } from '../../../common/enums/BroadcastType';

/**
 * Validates if at least one language has a non-empty value
 */
export const hasMultiLanguageValue = (
  values: IMultiLanguageValue[]
): boolean => {
  return values.some((item) => item.value.trim() !== '');
};

/**
 * Validates all required fields for broadcast creation
 */
export const validateBroadcastForm = (params: {
  title: IMultiLanguageValue[];
  body: IMultiLanguageValue[];
  messageTitle: IMultiLanguageValue[];
  messageBody: IMultiLanguageValue[];
  file: File | null;
  scheduledAt: Date | null;
  type?: BroadcastType;
  ctaText?: IMultiLanguageValue[];
  externalUrl?: string;
}): string[] => {
  const errors: string[] = [];

  if (!hasMultiLanguageValue(params.title)) {
    errors.push('titleRequired');
  }

  if (!hasMultiLanguageValue(params.body)) {
    errors.push('descriptionRequired');
  }

  if (!hasMultiLanguageValue(params.messageTitle)) {
    errors.push('notifyTitleRequired');
  }

  if (!hasMultiLanguageValue(params.messageBody)) {
    errors.push('notifyBodyRequired');
  }

  if (!params.file) {
    errors.push('fileRequired');
  }

  if (!params.scheduledAt) {
    errors.push('scheduledAtRequired');
  }

  // Validate ADS metadata when type is ADS
  if (params.type === BroadcastType.Ads) {
    if (!params.ctaText || !hasMultiLanguageValue(params.ctaText)) {
      errors.push('ctaTextRequired');
    }

    if (!params.externalUrl || params.externalUrl.trim() === '') {
      errors.push('externalUrlRequired');
    } else if (!isValidUrl(params.externalUrl)) {
      errors.push('externalUrlInvalid');
    }
  }

  return errors;
};

/**
 * Validates if a string is a valid HTTP(S) URL
 */
const isValidUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
  } catch {
    return false;
  }
};
